import { render } from "./TermsNew.vue?vue&type=template&id=24dc02cc"
import script from "./TermsNew.vue?vue&type=script&lang=js"
export * from "./TermsNew.vue?vue&type=script&lang=js"

import "./TermsNew.vue?vue&type=style&index=0&id=24dc02cc&lang=css"

import exportComponent from "C:\\Users\\Adrian\\OneDrive\\Documents\\Appsanely Ltd\\thankU\\_thankuapp\\thanku\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__